<template>
  <!-- <v-app style="background-color: red;" fluid ma-0 pa-0 fill-height> -->

  <v-container>
    <v-layout xs12 column justify-space-around>
      <br />
      <v-flex offset-xs0 offset-md0 offset-sm0>
        <h1>Welcome</h1>
      </v-flex>
      <br />
      <v-container fluid row wrap justify-center pa-0 xs12>
        <v-layout row wrap justify-space-around>
          <v-flex xs12 sm12 md12 offset-xs0 offset-md0 offset-sm0>
            <!-- <v-img class="coverImg" :src="myImage" alt="LOGO"></v-img> -->
            <img
              class="coverImg"
              src="../assets/20190519_194800_0000.png"
              alt="LOGO"
            />
          </v-flex>
        </v-layout>
      </v-container>
      <br />
      <br />
      <hr />
      <br />
      <br />
      <!-- <v-flex xs12 sm6 md6 offset-xs0 offset-md0 offset-sm0>
          <h1>About Us</h1>
      </v-flex>-->
      <v-flex xs12 sm6 md6 offset-xs0 offset-md0 offset-sm0>
        <div class="about-content">
          <p>
            ABOUT US
          </p>

          <p>
            The Suburbs Directory was created as a buffer for businesses to
            effectively utilise specific social media platforms for the purpose
            of promoting their products and services to various communities
            around the Western Cape.
          </p>

          <p>
            By being responsible for the running of each of our ten Facebook
            community groups we have been able to effectively manage and provide
            a reputable platform for businesses to market themselves to the
            public.
          </p>

          <p>
            We have kept each group area specific by requiring a set of
            questions to be answered before approval. Our dedicated team of
            admins approve and delete each and every post, thus being able to
            keep content relevant and engaging to all our members.
          </p>

          <p>
            The Suburbs Directory are a local, Cape Town based business who are
            dedicated to seeing our community uplifted and thriving. In order to
            be a proactive participant, we have chosen to support one charity in
            each of our 7 suburbs. 10% of the advertising fees made in each area
            are given to a chosen charity at the end of each year.
          </p>

          <p>
            The Suburbs Directory currently consists of ten Facebook groups, 7
            “base” groups and 3 “add-on” groups. The groups are as follows:
          </p>
          <br />
          <ul>
            <li>
              <a
                href="https://www.facebook.com/groups/SOUTHPENINSULACOMMUNITYGROUP"
                target="_blank"
                >South Peninsula Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/SOUTHERNSUBURBSCOMMUNITYGROUP"
                target="_blank"
                >Southern Suburbs Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/ATLANTICSEABOARDCOMMUNITYGROUP"
                target="_blank"
                >Atlantic Seaboard Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/NORTHERNSUBURBSCOMMUNITYGROUP"
                target="_blank"
                >Northern Suburbs Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/HELDERBERGCOMMUNITYGROUP"
                target="_blank"
                >Helderberg Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/CITYBOWLCOMMUNITYGROUP"
                target="_blank"
                >City Bowl Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/WESTCOASTCOMMUNITYGROUP"
                target="_blank"
                >West Coast Community Group</a
              >
            </li>
          </ul>
          <br /><br />
          <ul>
            <li>
              <a
                href="https://www.facebook.com/groups/821666047881290"
                target="_blank"
                >Constantia & Surrounds Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/BischopscourtCommunity"
                target="_blank"
                >Bishopscourt Community Group</a
              >
            </li>
            <li>
              <a
                href="https://www.facebook.com/groups/UpperClaremont"
                target="_blank"
                >Upper Claremont Community Group</a
              >
            </li>
          </ul>
          <br />
          <p>
            We are continuously working on growing the above groups and realise
            that overtime they will become sufficiently populated. We, however,
            do not accept people for the sake of numbers and realise that this
            means that our growth will happen gradually at a steady pace, but
            authentically, resulting in groups well organised with members
            relevant to each community.
          </p>

          <p>
            We look forward to having you onboard with us and growing together.
          </p>
          <br />
          <p>
            <strong
              ><a
                href="https://www.facebook.com/suburbsdirectory"
                target="_blank"
                >The Suburbs Directory Team</a
              ></strong
            >
          </p>
        </div>
      </v-flex>
      <br />
      <br />
      <v-layout row wrap justify-space-around>
        <v-flex xs12 sm6 md4 offset-xs0 offset-md0 offset-sm0>
          <!-- <div style="display: flex; justify-content: space-between;"> -->
          <!-- <img
            class="aboutBottom"
            src="../assets/20190519_194800_0000.png"
            alt="LOGO"
          />-->
          <img
            class="aboutBottom"
            src="../assets/Screen Shot 2019-05-27 at 3.30.49 PM.png"
            alt="LOGO"
          />
          <!-- <img class="aboutBottom" src="../assets/Screen Shot 2019-05-27 at 3.31.32 PM.png" alt="LOGO"> -->
          <!-- </div> -->
        </v-flex>
        <v-flex xs12 sm6 md4 offset-xs0 offset-md0 offset-sm0>
          <!-- <div style="display: flex; justify-content: space-between;"> -->
          <!-- <img class="aboutBottom" src="../assets/Screen Shot 2019-05-27 at 3.30.49 PM.png" alt="LOGO"> -->
          <img
            class="aboutBottom"
            src="../assets/Screen Shot 2019-05-27 at 3.31.32 PM.png"
            alt="LOGO"
          />
          <!-- </div> -->
        </v-flex>
      </v-layout>
    </v-layout>
    <!-- </v-layout> -->
  </v-container>

  <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <!-- </v-app> -->
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      myImage: require("../assets/20190519_194800_0000.png")
    };
  },
  components: {}
};
</script>

<style scoped>
ul {
  list-style: none;
}
li {
  font-size: 120%;
  margin: 5px 0;
}
h1 {
  font-size: 350%;
}
img {
  border: 10px solid #f4ebde;
  width: 100%;
  /* background-color: #F4EBDE; */
}
.coverImg {
  border: 5px solid #f4ebde;
  width: 100%;
  /* height: 500%; */
}
.about1 {
  width: 100%;
}
.aboutBottom {
  width: 110%;
}
p {
  font-size: 120%;
}
@media screen and (max-width: 768px) {
  img {
    /* width: 100%; */
    margin: 0%;
    height: 80%;
    /* width: 120%; */

    /* height: 100%; */
  }
  .coverImg {
    border: 1px solid #f4ebde;
    margin-left: 0px;
    padding-left: 0px;
  }
}
</style>
